/**
 * An application error is an error that is expected to be thrown in the application as apposed to errors which are
 * caused by type errors for example.
 */
export class ApplicationError extends Error {}
